(() => {
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) {
        const play = target.play();
        if (play) play.catch(() => { target.controls = true; });
      } else target.pause();
    });
  }, {threshold: 0.15});
  function init() {
    document.querySelectorAll('video.cca-viewport-video').forEach(video => {
      if (!seen.has(video)) { seen.add(video); observer.observe(video); }
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
